import React from 'react';
import ViewBoardsIcon from '@heroicons/react/outline/ViewBoardsIcon.js';
import { BlockType } from '../../types/index.js';
import { AccordionBlock as Component } from './Block.js';
import { AccordionBlockSettings as Settings } from './Settings.js';
export const RegisteredAccordionBlock = (intl) => {
    const { $t } = intl;
    return {
        recommendedName: 'Accordion',
        Component,
        config: {
            type: BlockType.Block,
            usable: true,
            displayName: $t({
                id: 'Blocks.Accordion.DisplayName',
                defaultMessage: 'Accordions',
            }),
            Settings,
            Icon: React.createElement(ViewBoardsIcon, { className: "rotate-90" }),
            defaultProps: {
                title: $t({
                    id: 'Blocks.Accordion.Title',
                    defaultMessage: 'Accordions',
                }),
                items: [
                    {
                        title: $t({
                            id: 'Blocks.Accordion.ItemTitle',
                            defaultMessage: 'Accordion title',
                        }),
                        description: $t({
                            id: 'Blocks.Accordion.ItemDescription',
                            defaultMessage: 'This is an example of a paragraph text inside of an accordion that’s visibly open.',
                        }),
                        defaultOpen: true,
                    },
                ],
            },
        },
    };
};
//# sourceMappingURL=registered.js.map